//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import mpvueCityPicker from '@/components/mpvue-citypicker/mpvueCityPicker.vue'
	export default {
		data() {
			return {
				addressData: {
					deliveryAddressId:0,
					receiverName: '',
					phone: '',
					addressName: '收件地区',
					provinceCode:'',
					cityCode:'',
					districtCode:'',
					detailAddress: '',
					status: 0
				},
				themeColor: '#007AFF',
				cityPickerValueDefault: [0, 0, 0],
			}
		},
		components:{
			mpvueCityPicker
			},
		methods:{
			onCancel(){
				
			},
			receiverNameInput(e){
				this.addressData.receiverName=e.target.value
			},
			phoneInput(e){
				this.addressData.phone=e.target.value
			},
			addressInput(e){
				this.addressData.detailAddress=e.target.value
			},
			submit(){
				let _this=this
				for(let key in this.addressData){
					if(this.addressData[key]===''||this.addressData[key]==='收件地区'){
							// this.$emit('hide')
						uni.showToast({
							title:'必填项不能为空',
            				icon:'none'
						})
						return
					}
				}
				if(!this.testName()) {
					uni.showToast({
						title:'收货人不能为空或格式不正确！',
						icon:'none'
					})
					return
				}
				if(!this.testPhone()) {
					uni.showToast({
						title:'手机号不能为空或格式不正确！',
						icon:'none'
					})
					return
				}
				this.addressData.address=this.addressData.addressName+this.addressData.detailAddress
				this.$ajax({
					method: 'post',
					url: this.addressData.deliveryAddressId === 0 ? '/weChat/specialtyProduct/addDeliveryAddress' : '/weChat/specialtyProduct/updateDeliveryAddress',
					data: {
					  ...this.addressData,
					  // memberId:'599267700576878592'
					  memberId:this.$store.state.userInfo.memberId
					}
				}).then(res=>{
					_this.$emit('hide')
					_this.$emit('getList')
					_this.$emit('choseAddress',_this.addressData)
				})
				this.cityPickerValueDefault = [0, 0, 0]
			},
			onConfirm(e){
				this.addressData.provinceCode=e.cityCode.substring(0,2)+'0000000000'
				this.addressData.cityCode=e.cityCode.substring(0,4)+'00000000'
				this.addressData.districtCode=e.cityCode+'000000'
				this.addressData.addressName=e.label
			},
			showMulLinkageThreePicker() {
				this.$refs.mpvueCityPicker.show()
			}, 
			openPicker() {
            this.lotusAddressData.visible = true;
			},
			switchChange(val){
				this.addressData.status=val.detail.value?1:0
			},
			edit(item){				
				// item.addressName=item.provinceName+item.cityName+item.districtName
				this.addressData=item
				this.$set(this.addressData,'addressName',item.provinceName+item.cityName+item.districtName)
			},
			reset(){
				this.addressData.receiverName=''
				this.addressData.phone=''
				this.addressData.provinceCode=''
				this.addressData.addressName= '收件地区',
				this.addressData.districtCode=''
				this.addressData.detailAddress=''
				this.addressData.deliveryAddressId=0
				this.addressData.status=0
			},
			del(){
				let _this=this
				this.$ajax({
					method: 'post',
					url: '/weChat/specialtyProduct/deletedDeliveryAddress',
					data: {
					  deliveryAddressId: this.addressData.deliveryAddressId
					},
					success:function(res){
						
					}
			    }).then(res=>{
					uni.showToast({
						title:'删除成功',
						icon:'none'
					})
					_this.$emit('getList')
					_this.$emit('hide')
				})
			},
			testName () {
				return (
					!!this.addressData.receiverName &&
					/^[\u4e00-\u9fa5.a-zA-Z0-9]+$/.test(this.addressData.receiverName)
				)
			},
			testPhone () {
				return /^1[345789]\d{9}$/.test(this.addressData.phone)
			}
		}
		
	}
